export const getStyleInteger = (element: HTMLElement, prop: string) =>
  Number.parseInt(window.getComputedStyle(element).getPropertyValue(prop), 10);

export const getPseudoStyleInteger = <E extends HTMLElement = HTMLElement>(
  element: E,
  prop: string,
  pseudoElement: "before" | "after" = "before"
) =>
  Number.parseInt(
    window
      .getComputedStyle(element, ":" + pseudoElement)
      .getPropertyValue(prop),
    10
  );
